import request from '@/utils/request';

const baseURL = process.env.VUE_APP_SORTING;

/**
 * 分页查询落袋记录
 * @param {Object} data - 查询参数
 * @param {number} data.pageNumber - 页码
 * @param {number} data.pageSize - 每页条数
 * @param {Object} data.params - 筛选条件
 * @returns {Promise}
 */
export function getUploadRecordPage(data) {
  return request({
    baseURL: baseURL,
    url: '/uploadRecord/page',
    method: 'post',
    data
  });
}

/**
 * 按格口获取落袋数据 (用于封袋预览)
 * @param {Object} params - 查询参数
 * @param {string} params.machineCode - 设备编码
 * @param {string} params.chuteNumber - 格口号
 * @returns {Promise}
 */
export function getListByChute(params) {
  return request({
    baseURL: baseURL,
    url: '/sorting/getListByChute',
    method: 'get',
    params
  });
}

/**
 * 封袋操作
 * @param {Object} data - 请求参数
 * @param {string} data.chuteCode - 格口编码 (格口号-设备编码)
 * @param {string} data.bagNumber - 封袋号
 * @returns {Promise}
 */
export function uploadChuteData(data) {
  return request({
    baseURL: baseURL,
    url: '/sorting/uploadChuteData',
    method: 'post',
    data
  });
}

/**
 * 获取分拣机格口数据
 * @param {Object} params - 查询参数
 * @param {string} params.chuteCode - 格口编码 (格口号-设备编码)
 * @returns {Promise}
 */
export function getChuteData(params) {
  return request({
    baseURL: baseURL,
    url: '/getChuteData',
    method: 'get',
    params
  });
}

/**
 * 获取格口数据统计
 * @param {Object} params - 查询参数
 * @param {string} params.machineCode - 设备编码
 * @param {string} params.chuteNumber - 格口号
 * @returns {Promise}
 */
export function getCountByChute(params) {
  return request({
    baseURL: baseURL,
    url: '/sorting/getCountByChute',
    method: 'get',
    params
  });
}

/**
 * 移除出袋
 * @param {Object} data - 请求参数
 * @param {string} data.chuteCode - 格口编码 (格口号-设备编码)
 * @param {string} data.scanNumber - 扫描单号（运单号或条码）
 * @returns {Promise}
 */
export function removeFromBag(data) {
  return request({
    baseURL: baseURL,
    url: '/sorting/removeFromBag',
    method: 'post',
    data
  });
}

// 仓内作业统计
export function sortingOperations(data) {
  return request({
    baseURL: baseURL,
    url: '/metric/sortingOperations/statistics',
    method: 'post',
    data
  });
}

// 仓内作业统计
export function sortingOperationsExport(data) {
  return request({
    baseURL: baseURL,
    url: '/metric/sortingOperations/statistics/export',
    method: 'post',
    data
  });
}
